import TranslationText from '@Components/Utilities/TranslationText';

const WantToBuyListing = (props) => {

    const wtbInfo = (label, value) => {
        if (label && value) {
            return (
                <div>
                    {value && (value + '').trim() != '' &&
                        <span className='wtb-entry-info'>
                            <strong>{label}: </strong>
                            {value}
                        </span>}
                </div>
            );
        } else {
            return (<></>);
        }
    };

    return (
        <div className='wtb-entry'>
            <div className='wtb-equip-info'>
                <h3>{props.Manufacturer} {props.Model}</h3>
                <div className='wtb-half'>
                    {wtbInfo(<TranslationText tKey='sandhills.status' />, props.Status)}
                    {wtbInfo(props.EquipmentTypeDisplayLabel, props.CategoryDisplayName)}
                    {wtbInfo(<TranslationText tKey='sandhills.quantity' />, props.QuantityNeeded)}
                    {wtbInfo(<TranslationText tKey='sandhills.PlanningToBuy' />, props.PlanningToBuyDisplayText)}
                    {wtbInfo(<TranslationText tKey='sandhills.location' />, (props.City ? (props.City + ',') : '') + (props.State ? props.State : props.Country))}
                </div>
                <div className='wtb-half'>
                    {wtbInfo(<TranslationText tKey='sandhills.shortdesc' />, props.ShortDescription)}
                    {wtbInfo(<TranslationText tKey='sandhills.Year' />, (props.YearFrom > 0 && props.YearFrom == props.YearTo ? (props.YearFrom) : (props.YearFrom > 0 || props.YearTo > 0 ? (props.YearFrom > 0 ? props.YearFrom : '1900') + ' to ' + (props.YearTo > 0 ? props.YearTo : 'Present') : '')))}
                    {props.FormattedPrice &&
                        wtbInfo(<TranslationText tKey='sandhills.PriceLimit' />, (props.CurrencyCode + ' ' + props.FormattedPrice))}
                    {wtbInfo(<TranslationText tKey='sandhills.othercomments' />, props.OtherComments)}
                </div>
                <div className='wtb-update-delete'>
                    <span className='update-time'><strong><TranslationText tKey='sandhills.updated' />:</strong> {props.LastModifiedDate}</span>
                    <span className='wtb-edit'><a href={props.WantToBuyBaseUrl + '/' + props.WantToBuyMessageID}><i className='fas fa-edit'></i> <TranslationText tKey='sandhills.edit' /></a></span>
                    <span className='wtb-delete' id='loadMore'><a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); props.onDelete(); } }} onClick={props.onDelete}><i className='fas fa-trash'></i> <TranslationText tKey='sandhills.Delete' /></a></span>
                </div>
            </div>
        </div>
    );
};

export default WantToBuyListing;